import { createRouter, createWebHistory } from 'vue-router'
import Timeline from '../views/Timeline.vue'
import Messages from "@/views/Messages.vue";
import Ideas from "@/views/Ideas.vue";
import People from "@/views/People.vue";
import SetupView from '../views/Setup.vue';
import MainLayout from '../layouts/MainLayout.vue';
import SetupLayout from '../layouts/SetupLayout.vue';
import { useEventStore } from '@/stores/event-store'
import { localDB } from '@/migrate'
import { eventsTable } from '../../client-db/src/db/schema'
import { eq } from 'drizzle-orm'
import Verify from '@/components/Verify.vue'
import { useAuthClient } from '@/stores/auth-store.ts'

const { hasLocalAccount } = useAuthClient()

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // Setup routes (different layout)
    {
      path: '/setup',
      component: SetupLayout,
      children: [
        {
          path: '',
          name: 'setup',
          component: SetupView,
        }
      ]
    },
    {
      path: '/verify',
      name: 'verify',
      component: Verify,
    },
    // Main app routes (main layout)
    {
      path: '/',
      component: MainLayout,
      children: [
        {
          path: '',
          name: 'timeline',
          component: Timeline,
          meta: { requiresAuth: true }
        },
        {
          path: '/event/:id',
          name: 'event',
          component: Timeline,
          meta: { requiresAuth: true }
        },
        {
          path: '/activity',
          name: 'activity',
          component: Messages,
          meta: { requiresAuth: true }
        },
        {
          path: '/ideas',
          name: 'ideas',
          component: Ideas,
          meta: { requiresAuth: true }
        },
        {
          path: '/people',
          name: 'people',
          component: People,
          meta: { requiresAuth: true }
        },
        {
          path: '/about',
          name: 'about',
          component: () => import('../views/AboutView.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: '/more',
          name: 'more',
          component: () => import('../views/More.vue'),
          meta: { requiresAuth: true }
        },
      ]
    }
  ],
})

// Global navigation guard
router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) { //TODO: Truly lock this down at some point rather than all in SPA
    if (!hasLocalAccount.value) {
      next('/setup')
      return
    }
  }

  if (to.name === 'event') {
    const eventStore = useEventStore()
    const eventId = parseInt(to.params.id as string, 10)

    if (Number.isNaN(eventId)) {
      next('/')
      return
    }

    try {
      const [event] = await localDB.select().from(eventsTable).where(eq(eventsTable.id, eventId)).limit(1)

      if (event) {
        (eventStore.currentEvent as any) = event //TODO: Fix this so everything is based of drizzle schema!
        eventStore.showEvent = true
        next()
        return
      }
      next('/')
      return
    } catch (error) {
      console.error('Error loading event:', error)
      next('/')
      return
    }
  }

  next()
})

export default router
